export enum ImageAspectRatioEnum {
  SQUARE = 1,
  RECTANGLE_SMALL_H = 4 / 3,
  RECTANGLE_SMALL_V = 3 / 4,
  PORTRAIT = 9 / 16,
  LANDSCAPE = 16 / 9
}

export enum PortfolioPriorityEnum {
  BIG_IMAGE = 1,
  MEDIUM_IMAGE = 2,
  SMALL_IMAGE = 3
}

export enum FileTypesEnum {
  PDF = 'pdf',
  NEWS_IMAGE = 'newsImage',
  PDF_IMAGE = 'pdfImage',
  IMAGE = 'image'
}

export enum ImageSizeEnum {
  SMALL = 'small',
  LARGE = 'large'
}

export enum MediaTypesEnum {
  IMAGE = 'image',
  VIDEO = 'video'
}
